var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadedTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_2659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1145 175.859C136.439 175.859 175.615 136.684 175.615 88.3594C175.615 40.0345 136.439 0.859375 88.1145 0.859375C39.7896 0.859375 0.614502 40.0345 0.614502 88.3594C0.614502 136.684 39.7896 175.859 88.1145 175.859Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2393 93.0469L78.7393 130.547L134.989 46.1719",
    stroke: "#FFB858",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_2659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 175,
    fill: "white",
    transform: "translate(0 0.859375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedTick);
export default __webpack_public_path__ + "static/media/uploaded-tick.ebc1c9211a23ac6c34de84fba4ea4160.svg";
export { ForwardRef as ReactComponent };